import RecommendCourtesy from './recommend-courtesy'
export default RecommendCourtesy